import { render } from "./chatAdmin.vue?vue&type=template&id=6f764e6f&scoped=true"
import script from "./chatAdmin.vue?vue&type=script&lang=js"
export * from "./chatAdmin.vue?vue&type=script&lang=js"

import "./chatAdmin.vue?vue&type=style&index=0&id=6f764e6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f764e6f"]])

export default __exports__